module.exports = __webpack_public_path__ + "static/media/emergency.5f56318c.svg";